(function () {
  'use strict';
  if (!location.pathname.includes('/collections/')) return;
  var config = document.getElementById('grayish-infinite-config');
  if (!config) return;
  var messages = JSON.parse(config.textContent);
  var selector = '[data-productgrid-items]';
  var current = null;
  var scheduled = 0;

  function pageNumber(url) {
    return Math.max(1, Number(new URL(url, location.href).searchParams.get('page')) || 1);
  }

  function nextPage(doc, base) {
    var number = pageNumber(base);
    var pagination = doc.querySelector('.pagination--container');
    if (!pagination) return null;
    var links = Array.from(pagination.querySelectorAll('a[href]'));
    var found = links.find(function (link) {
      var url = new URL(link.getAttribute('href'), base);
      return url.origin === location.origin && url.pathname === new URL(base).pathname && pageNumber(url) === number + 1;
    });
    if (!found) return null;
    var url = new URL(base);
    url.searchParams.delete('section_id');
    url.searchParams.set('page', String(number + 1));
    return url.href;
  }

  function productKey(node) {
    var link = node.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var path = new URL(link.getAttribute('href'), location.href).pathname;
    return path.slice(path.lastIndexOf('/products/'));
  }

  function storageKey(url) {
    var value = new URL(url);
    value.searchParams.delete('page');
    value.searchParams.delete('section_id');
    value.searchParams.sort();
    return 'grayish:collection-page:' + value.pathname + value.search;
  }

  function update(state) {
    state.button.disabled = state.loading;
    state.button.textContent = state.failed ? messages.retry : messages.more;
    state.button.style.display = state.next ? '' : 'none';
    state.link.style.display = state.next ? '' : 'none';
    if (state.next) state.link.href = state.next;
    state.status.textContent = state.loading ? messages.loading : state.failed ? messages.failed : state.next ? '' : messages.done;
  }

  function nearEnd(state) {
    var rect = state.sentinel.getBoundingClientRect();
    return rect.top <= document.documentElement.clientHeight + 600 && rect.bottom >= -600;
  }

  function check(state) {
    if (state.dead || state.loading || state.failed || !state.next || document.hidden) return;
    if (state.key !== location.href || document.querySelector(selector) !== state.grid) return;
    if (pageNumber(state.url) < state.restoreTarget || nearEnd(state)) load(state);
  }

  async function load(state) {
    if (state.dead || state.loading || !state.next) return;
    if (state.key !== location.href || document.querySelector(selector) !== state.grid) return;
    state.loading = true;
    state.failed = false;
    state.controller = new AbortController();
    var timer = setTimeout(function () { state.controller.abort(); }, 15000);
    var target = state.next;
    update(state);
    try {
      var url = new URL(target);
      if (state.sectionId) url.searchParams.set('section_id', state.sectionId);
      var response = await fetch(url.href, { credentials: 'same-origin', signal: state.controller.signal });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (state.dead || state.key !== location.href || document.querySelector(selector) !== state.grid) return;
      var grid = doc.querySelector(selector);
      if (!grid) throw new Error('Product grid missing');
      var fragment = document.createDocumentFragment();
      var added = 0;
      Array.from(grid.children).forEach(function (node) {
        var key = productKey(node);
        if (!key || state.seen.has(key)) return;
        state.seen.add(key);
        fragment.appendChild(document.importNode(node, true));
        added++;
      });
      if (!added) throw new Error('No new products');
      state.grid.appendChild(fragment);
      state.url = target;
      state.next = nextPage(doc, target);
      try { sessionStorage.setItem(storageKey(state.key), String(pageNumber(target))); } catch (error) {}
      document.dispatchEvent(new CustomEvent('cstt:products-loaded', { detail: { page: pageNumber(target), grid: state.grid } }));
    } catch (error) {
      if (!state.dead) state.failed = true;
    } finally {
      clearTimeout(timer);
      state.loading = false;
      if (!state.dead) {
        update(state);
        requestAnimationFrame(function () { check(state); });
      }
    }
  }

  function destroy(state) {
    state.dead = true;
    if (state.controller) state.controller.abort();
    if (state.observer) state.observer.disconnect();
    state.sentinel.remove();
    state.pagination.style.display = state.originalDisplay;
  }

  function mount() {
    scheduled = 0;
    var grid = document.querySelector(selector);
    if (current && current.grid === grid && current.key === location.href && grid.isConnected) return;
    var fresh = !!current;
    if (current) { destroy(current); current = null; }
    if (!grid) return;
    var next = nextPage(document, location.href);
    var pagination = grid.closest('[id^="shopify-section-"]')?.querySelector('.pagination--container') || document.querySelector('.pagination--container');
    if (!next || !pagination) return;
    var sentinel = document.createElement('div');
    sentinel.dataset.grayishInfinite = '';
    sentinel.style.cssText = 'text-align:center;padding:1rem;';
    var status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button-secondary';
    var link = document.createElement('a');
    link.textContent = messages.open_page;
    link.style.cssText = 'display:inline-block;margin-inline:1rem;padding:0.75rem;text-decoration:underline;';
    sentinel.append(status, button, link);
    grid.after(sentinel);
    var page = pageNumber(location.href);
    var saved = page;
    if (!fresh) {
      try { saved = Number(sessionStorage.getItem(storageKey(location.href))) || page; } catch (error) {}
    }
    var state = {
      grid: grid, pagination: pagination, originalDisplay: pagination.style.display,
      sentinel: sentinel, status: status, button: button, link: link,
      key: location.href, url: location.href, next: next, loading: false, failed: false, dead: false,
      restoreTarget: Math.max(page, Math.min(saved, page + 20)),
      sectionId: grid.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', ''),
      seen: new Set(Array.from(grid.children).map(productKey).filter(Boolean))
    };
    current = state;
    pagination.style.display = 'none';
    button.addEventListener('click', function () { load(state); });
    if (typeof IntersectionObserver !== 'undefined') {
      state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) check(state);
      }, { rootMargin: '600px 0px' });
      state.observer.observe(sentinel);
    }
    update(state);
    requestAnimationFrame(function () { check(state); });
  }

  function scheduleMount() {
    if (!scheduled) scheduled = setTimeout(mount, 80);
  }

  function start() {
    mount();
    new MutationObserver(scheduleMount).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', scheduleMount);
    window.addEventListener('scroll', function () { if (current) check(current); }, { passive: true });
    window.addEventListener('resize', function () { if (current) check(current); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (current) check(current); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
